import { jsx as o, jsxs as z, Fragment as v } from "react/jsx-runtime";
import q, { useState as B, useId as F, useEffect as P, cloneElement as w } from "react";
import { c as h } from "../clsx-OuTLNxxd.js";
import { A as R, E as U } from "../index-PMSPXTub.js";
import '../Accordion.css';const j = "320px", L = "600px", O = "1025px", D = "_header_m90op_33", G = "_splitHeader_m90op_37", J = "_iconSlot_m90op_43", K = "_heading_m90op_50", Q = "_toggle_m90op_57", X = "_triggerElement_m90op_66", Y = "_indicator_m90op_72", Z = "_trigger_m90op_66", M = "_contentElement_m90op_112", V = "_content_m90op_112", C = "_primary_m90op_132", N = "_secondary_m90op_135", ee = "_item_m90op_141", te = "_dense_m90op_141", ne = "_nav_m90op_234", oe = "_link_m90op_239", ie = "_headingText_m90op_271", ce = "_linkLabel_m90op_272", re = "_linkList_m90op_297", t = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: j,
  "mobile-wide": "480px",
  tablet: L,
  "tablet-wide": "800px",
  desktop: O,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  header: D,
  splitHeader: G,
  iconSlot: J,
  heading: K,
  toggle: Q,
  triggerElement: X,
  indicator: Y,
  trigger: Z,
  contentElement: M,
  content: V,
  primary: C,
  secondary: N,
  item: ee,
  dense: te,
  nav: ne,
  link: oe,
  headingText: ie,
  linkLabel: ce,
  linkList: re
}, le = (d) => {
  if (typeof requestAnimationFrame != "function")
    return d(), () => {
    };
  let x = 0;
  const c = requestAnimationFrame(() => {
    x = requestAnimationFrame(d);
  });
  return () => {
    cancelAnimationFrame(c), cancelAnimationFrame(x);
  };
}, de = ({
  animationDurationMs: d = 0,
  indicatorSize: x = "xsm",
  isOpen: c,
  isPanelLandmark: e = !0,
  onChange: g,
  stroke: W = "bold"
}) => {
  const [n, p] = B(c), s = d > 0, [y, _] = B(c), [u, a] = B(!!c), b = F(), m = F(), H = () => {
    g == null || g(!n), p(!n);
  };
  P(() => {
    c !== n && p(c);
  }, [c]), P(() => {
    if (!s) return;
    if (n)
      return _(!0), le(() => a(!0));
    a(!1);
    const r = setTimeout(() => _(!1), d);
    return () => clearTimeout(r);
  }, [n, s, d]);
  const f = {
    "aria-controls": m,
    // The watermark travels with the hook, not just with `Accordion.Item`. A caller that drives the
    // disclosure headlessly renders cxy's behaviour on markup of its own — the footer nav does — and
    // without this it is indistinguishable in the DOM from a hand-rolled toggle, which is the one
    // question `data-cxy-name` exists to answer.
    "data-cxy-name": "accordion",
    "aria-expanded": n,
    "data-state": n ? "open" : "closed",
    id: b,
    onClick: H
  }, i = {
    "aria-labelledby": b,
    className: t.contentElement,
    hidden: s ? !y : !n,
    id: m,
    ...e ? { role: "region" } : {},
    ...s ? { "data-animated": "" } : {},
    ...s && u ? { "data-enter": "" } : {}
  };
  return {
    headingProps: f,
    sectionProps: i,
    triggerClass: t.triggerElement,
    Indicator: () => W === "bold" ? /* @__PURE__ */ o(R, { className: t.indicator, size: x }) : /* @__PURE__ */ o(U, { className: t.indicator, size: x })
  };
}, pe = 300, xe = ({
  animationDurationMs: d = 0,
  chevronStroke: x = "bold",
  children: c,
  classNames: e,
  heading: g,
  headingAs: W = "h3",
  icon: n,
  indicator: p,
  indicatorSize: s = "xsm",
  isDense: y = !1,
  isOpen: _ = !1,
  isPanelLandmark: u = !0,
  links: a,
  onChange: b,
  onLinkClick: m,
  testId: H,
  toggleLabel: f,
  trackingAttribute: i,
  variant: r
}) => {
  const { Indicator: l, headingProps: E, sectionProps: A, triggerClass: I } = de({
    animationDurationMs: d,
    isOpen: _,
    isPanelLandmark: u,
    onChange: b,
    indicatorSize: s,
    stroke: x
  }), T = {
    ...E,
    ...i ? { "data-analytics": i } : {},
    ...H ? { "data-testid": H } : {},
    type: "button"
  }, { id: $, ...k } = T;
  return /* @__PURE__ */ z(
    "div",
    {
      className: h(
        t.item,
        { [t.dense]: y },
        r && r !== "bare" && t[r],
        e == null ? void 0 : e.wrapper
      ),
      "data-cxy-name": "accordion",
      children: [
        /* @__PURE__ */ o(W, { className: h(t.header, { [t.splitHeader]: f }, e == null ? void 0 : e.header), children: f ? /* @__PURE__ */ z(v, { children: [
          /* @__PURE__ */ z("span", { className: h(t.heading, e == null ? void 0 : e.heading), id: $, children: [
            n !== void 0 && /* @__PURE__ */ o("span", { className: t.iconSlot, children: n }),
            g
          ] }),
          /* @__PURE__ */ o(
            "button",
            {
              "aria-label": f,
              className: h(I, t.toggle, e == null ? void 0 : e.button),
              ...k,
              children: p ?? /* @__PURE__ */ o(l, {})
            }
          )
        ] }) : /* @__PURE__ */ z("button", { className: h(I, t.trigger, e == null ? void 0 : e.button), ...T, children: [
          n === void 0 ? g : /* @__PURE__ */ z(v, { children: [
            /* @__PURE__ */ o("span", { className: t.iconSlot, children: n }),
            /* @__PURE__ */ o("span", { className: h(t.headingText, e == null ? void 0 : e.heading), children: g })
          ] }),
          p ?? /* @__PURE__ */ o(l, {})
        ] }) }),
        /* @__PURE__ */ o(
          "div",
          {
            ...A,
            className: h(t.content, e == null ? void 0 : e.content),
            style: { "--cxy-accordion-duration": `${d}ms` },
            children: a ? /* @__PURE__ */ o("ul", { className: t.linkList, children: a.map((S) => /* @__PURE__ */ o("li", { children: /* @__PURE__ */ z("a", { className: t.link, href: S.href, onClick: () => m == null ? void 0 : m(S), children: [
              /* @__PURE__ */ o("span", { className: t.iconSlot, children: S.icon }),
              /* @__PURE__ */ o("span", { className: t.linkLabel, children: S.label })
            ] }) }, `${S.href}-${S.label}`)) }) : c
          }
        )
      ]
    }
  );
}, se = ({
  chevronStroke: d = "bold",
  children: x,
  defaultOpen: c,
  indicatorSize: e = "xsm",
  isDense: g = !1,
  name: W,
  onValueChange: n,
  type: p = "single",
  value: s,
  variant: y = "primary"
}) => {
  const _ = p === "multiple", u = s !== void 0, a = q.Children.toArray(x), b = c ? a.map(() => !0) : a.map((i) => !!i.props.isOpen), [m, H] = B(b), f = (i, r) => {
    let l = [];
    _ ? (l = [...m], l[r] = i) : (l = a.map(() => !1), i === !0 && (l[r] = !0)), H(l);
  };
  return /* @__PURE__ */ o(
    "div",
    {
      className: h(t.accordion, y !== "bare" && t[y]),
      "data-cxy-name": "accordion",
      "data-testid": "accordion-component",
      children: x && a.map(
        (i, r) => (
          // Cloned rather than rebuilt from named props: every prop the item declares reaches it,
          // so adding one to `AccordionItemProps` does not also require adding it here.
          w(i, {
            chevronStroke: d,
            indicatorSize: e,
            isDense: g,
            variant: y,
            isOpen: u ? i.props.value === s : m[r],
            key: `${W}-item-${r}`,
            onChange: (l) => {
              var E, A;
              (A = (E = i.props).onChange) == null || A.call(E, l), u ? n == null || n(l ? i.props.value ?? null : null) : f(l, r);
            }
          })
        )
      )
    }
  );
};
se.Item = xe;
export {
  pe as ACCORDION_FADE_DURATION_MS,
  se as Accordion,
  de as useToggle
};
